import { defineStore } from "pinia"

export const useChatinfo = defineStore('chatinfo', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        cardRecordCount: 0,
        msgCount: 0
    })
})